(function () {

seedWebApp.controller('DeleteModalCtrl', DeleteModal);

    function DeleteModal(translation, $uibModalInstance) {
        var ctrl = this;

        ctrl.translation = translation;

        ctrl.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        }

        ctrl.cancelDeletion = function () {
            $uibModalInstance.dismiss('cancel');
        }

        ctrl.confirmDeletion = function (isConfirmed) {
            $uibModalInstance.close(isConfirmed);
        }
    }
})();